interface IProps {
  image: string;
  businessName?: string;
  tagline?: string;
  buttonText?: string;
}

export const HeroCenter = ({
  image,
  businessName,
  tagline,
  buttonText,
}: IProps) => {
  const scrollToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      left: 0,
      behavior: "smooth",
    });
  };

  const cBusinessName = (
    <span className={"flex text-4xl lg:text-6xl text-primary-500"}>
      {businessName}
    </span>
  );

  const cTagline = (
    <h1
      className={"flex w-full font-bold text-4xl lg:text-8xl text-primary-700"}
    >
      {tagline}
    </h1>
  );

  const cButton = (
    <button
      className={
        "self-start lg:self-center lg:mt-4 py-2 px-6 rounded-lg font-bold lg:text-2xl text-primary-500 bg-secondary-600 hover:bg-secondary-400 transition-colors duration-300 ease-in-out"
      }
      onClick={scrollToBottom}
    >
      {buttonText}
    </button>
  );

  return (
    <section>
      <div className={"flex relative w-full h-[50vh] md:h-[70vh]"}>
        <img
          className={"h-full w-full object-cover overflow-hidden"}
          src={image}
          alt={"hero"}
          loading={"eager"}
          rel={"preload"}
        />
        <div
          className={
            "flex absolute right-0 h-full min-w-min max-w-full items-center justify-center bg-gradient-to-l from-secondary-200 lg:from-10% to-transparent"
          }
        >
          <div className={"flex flex-col w-3/4 lg:w-[60%] gap-8"}>
            {businessName && cBusinessName}
            {tagline && cTagline}
            {buttonText && cButton}
          </div>
        </div>
      </div>
    </section>
  );
};
